export const LOAD_ALBUM = 'LOAD_ALBUM';

export interface ILoadAlbum {
  isJustCreated?: boolean | null;
}

export const loadAlbum = (loadAlbumValues: ILoadAlbum) => ({
  type: LOAD_ALBUM,
  loadAlbumValues,
});
